import { useEffect, useState } from "react";
import useUiuxStore from "../../../store/useUiuxStore"
import ModalWrapper from "../modal/ModalWrapper";

const SheetModal = () => {

    const { sheetModalProps, setSheetModalVisible } = useUiuxStore();

    useEffect(() => {
        // window.open(sheetModalProps?.data, "_blank"); // 새 탭에서 Excel 파일 열기
    }, [sheetModalProps])

    return <ModalWrapper size="lg" overlay={true} width={1200}
        onOverlayClick={() => setSheetModalVisible(false)}
        onEscKeyDown={() => setSheetModalVisible(false)}>
        <div className="w-full h-full">
            <table className="table-auto border-collapse border w-full">
                <tbody>
                    {sheetModalProps?.data.map((row, rowIndex) => (
                        <tr key={rowIndex} className="border">
                            {row.map((cell, cellIndex) => (
                                <td key={cellIndex} className="border px-2 py-1">{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </ModalWrapper>
}

export default SheetModal;